import Vuex from 'vuex'
import Vue from 'vue'
import storage from '../lib/storage'
import { getSign } from '../api/requestList'
import history from '@/store/model/history.js'
import lockCar from './model/lockCar'
import deliveryAgent from './model/deliveryAgent'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    recruitScrollY: 0, // 记录原来的位置
    visitedList: [], // 缓存的页面
    repairInfo: {},
    auth: {},
    getOrder: {},
    returnInfo: {
      tempReturnList: []
    },
    // 重构验车项目
    returnCarInfo: {
      carInfoList: [], // 随车
      deliveryComponentLicenseList: [],
      retroInfoList: [], // 加装
      fixedLossDetails: [],
      tempReturnList: [],
      tireLossDetails: [] // 轮胎定损数据(媒介)
    },
    tempBoardCarInfo: [],
    tempRetroCarInfo: [],
    userInfo: storage.get('_userInfo'), // 要实时获取
    _signData: {},
    unfixedRemark: '', // 无定损备注
    costData: {},
    costPrams: {},
    onBoardcarInfo: [], // 随车信息
    retrofittingInfo: [], // 加装信息
    fixedNum: '', // 损伤定损随机数
    oldBoardCarInfo: JSON.parse(window.localStorage.getItem('oldBoardCarInfo')) || {},
    oldRetrofittingCarInfo: JSON.parse(window.localStorage.getItem('oldRetrofittingCarInfo')) || {},
    selectedOrders: [], // 选中的工单
    beginReturnCarTime: '', // 开始退车时间
    isJump: false, // 退车 - 是否点击车辆定损弹窗- 验车项目跳转到定损页面
    isJumpCompliancePhoto: false, // 售车交车 - 是否点击车辆照片及其他弹窗- 合规照片上传跳转到合规照片上传页面
    defaultStationId: '', // 默认场站
    // 默认选中的选项
    currentIndex: 0, // 工单类型
    currentBtnIndex: 0, // 状态类型,
    selectCurrentVehicle: '', // 租赁交车选中的车辆
    beforeJumpCompliancePhotoData: '', // 跳转合规照片前存储数据
    isSpaceToggle: false
  },
  getters: {
    visitedList: state => state.visitedList, // 是否需要缓存
    repairInfo: state => state.repairInfo,
    returnInfo: state => state.returnInfo,
    userInfo: state => state.userInfo,
    getAuth: state => state.auth,
    _signData: state => state._signData,
    unfixedRemark: state => state.unfixedRemark,
    costData: state => state.costData,
    costPrams: state => state.costPrams,
    getSpaceToggle: state => state.isSpaceToggle,
    returnCarInfo: state => state.returnCarInfo,
    historyIndex: state => state.history.index
  },
  mutations: {
    changeRecruitScrollY(state, evt) {
      state.recruitScrollY = evt
      console.log(evt)
    },
    setCostPrams(state, evt) {
      state.costPrams = evt
    },
    setCostData(state, evt) {
      state.costData = evt
    },
    setOldBoardCarInfo(state, { id, options }) {
      state.oldBoardCarInfo[id] = options
      state.tempBoardCarInfo = []
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => !item.flag || item.fixedType == 34)
      options.forEach(item => {
        if (item.componentStatus == 0) {
          state.tempBoardCarInfo.push({
            attachMentList: [],
            fixedLossDetail: `${item.componentName}项目退车和提车不一致`,
            fixedLossMoney: item.componentPrice,
            fixedLossName: item.componentName,
            fixedType: 33,
            hasOnLoss: 1,
            flag: true
          })
        }
      })
      state.returnCarInfo.fixedLossDetails.push(...state.tempBoardCarInfo)
      window.localStorage.setItem('oldBoardCarInfo', JSON.stringify(state.oldBoardCarInfo))
    },
    setOldRetrofittingCarInfo(state, { id, options }) {
      state.oldRetrofittingCarInfo[id] = options
      state.tempRetroCarInfo = []
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => !item.flag || item.fixedType == 33)
      options.forEach(item => {
        if (item.componentStatus == 0) {
          state.tempRetroCarInfo.push({
            attachMentList: [],
            fixedLossDetail: `${item.componentName}项目退车和提车不一致`,
            fixedLossMoney: item.componentPrice,
            fixedLossName: item.componentName,
            fixedType: 34,
            hasOnLoss: 1,
            flag: true
          })
        }
      })
      state.returnCarInfo.fixedLossDetails.push(...state.tempRetroCarInfo)
      window.localStorage.setItem('oldRetrofittingCarInfo', JSON.stringify(state.oldRetrofittingCarInfo))
    },
    setFixedNum(state, num) {
      state.fixedNum = num
    },
    removeFixedNum(state) {
      state.fixedNum = ''
    },
    setOnBoardCarInfo(state, arr) {
      state.onBoardcarInfo = arr
    },
    setRetrofittingInfo(state, arr) {
      state.retrofittingInfo = arr
    },
    removeCarInfo(state) {
      state.onBoardcarInfo = state.retrofittingInfo = []
    },
    addVisited(state, evt) {
      state.visitedList.push(evt)
    },
    clearVisitedList(state, evt = {}) {
      if (evt.name) {
        const index = state.visitedList.indexOf(evt.name)
        if (index !== -1) {
          state.visitedList.splice(index, 1)
        }
      } else {
        state.visitedList = []
      }
    },
    setReturnInfo(state, evt) {
      state.returnInfo[evt.name] = evt.data
    },
    delReturnItem(state, inx) {
      state.returnInfo.baseInfo.fixedLossDetails.splice(inx, 1)
    },
    setReturnItem(state, evt) {
      state.returnInfo.baseInfo.fixedLossDetails[evt['index']] = evt.data
    },
    pushTempReturnList(state, data) {
      state.returnInfo.tempReturnList.push(data)
    },
    pushReturnItem(state, data) {
      if (state.returnInfo && state.returnInfo.baseInfo && state.returnInfo.baseInfo.fixedLossDetails) {
        state.returnInfo.baseInfo.fixedLossDetails.push(data)
      }
    },
    // 重构验车项目
    pushReturnCarItem(state, data) {
      state.returnCarInfo.fixedLossDetails.push(data)
    },
    pushTempReturnCarList(state, data) {
      state.returnCarInfo.tempReturnList.push(data)
    },
    setReturnCarItem(state, evt) {
      state.returnCarInfo.fixedLossDetails[evt['index']] = evt.data
    },
    setReturnCarInfo(state, evt) {
      state.returnCarInfo[evt.name] = evt.data
    },
    delReturnCarItem(state, inx) {
      state.returnCarInfo.fixedLossDetails.splice(inx, 1)
    },
    concatReturnCarInfo(state, arr) {
      state.returnCarInfo.fixedLossDetails = [...state.returnCarInfo.fixedLossDetails, ...arr]
    },
    removeReturnCarInfo(state) {
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => !item.flag)
    },
    initalReturnCarInfo(state, data) {
      state.returnCarInfo.fixedLossDetails = data
    },
    resetCacheReturnCarInfo(state) {
      state.returnCarInfo.fixedLossDetails = []
    },
    addTireLossDetails(state, data) {
      state.returnCarInfo.tireLossDetails = data
    },
    resetTireLossDetails(state) {
      state.returnCarInfo.tireLossDetails = []
    },
    clearReturnCarInfo(state) {
      state.returnCarInfo = {
        fixedLossDetails: [],
        tempReturnList: [],
        tireLossDetails: [],
        carInfoList: [],
        deliveryComponentLicenseList: [],
        retroInfoList: []
      }
    },
    // 租赁退车 - 随车信息
    setCarInfoListOptions(state, data) {
      state.returnCarInfo.carInfoList = data
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => item.fixedType != 33)
      state.returnCarInfo.fixedLossDetails = [...state.returnCarInfo.fixedLossDetails, ...state.returnCarInfo.carInfoList]
    },
    // 租赁退车 - 车务证照
    setVehicleLicenseOptions(state, data) {
      state.returnCarInfo.deliveryComponentLicenseList = data
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => item.fixedType != 36)
      state.returnCarInfo.fixedLossDetails = [...state.returnCarInfo.fixedLossDetails, ...state.returnCarInfo.deliveryComponentLicenseList]
    },
    // 租赁退车 - 加装设备
    setRetroListOptions(state, data) {
      state.returnCarInfo.retroInfoList = data
      state.returnCarInfo.fixedLossDetails = state.returnCarInfo.fixedLossDetails.filter(item => item.fixedType != 34)
      state.returnCarInfo.fixedLossDetails = [...state.returnCarInfo.fixedLossDetails, ...state.returnCarInfo.retroInfoList]
    },
    // 设置开始退车时间
    setReturnCarTime(state, data) {
      state.beginReturnCarTime = data
    },
    // 重置退车时间
    resetReturnCarTime(state) {
      state.beginReturnCarTime = ''
    },
    // 设置默认场站
    setDefaultStationId(state, data) {
      state.defaultStationId = data
    },
    // 设置默认选中类型项
    setCurrentIndex(state, data) {
      state.currentIndex = data
    },
    // 设置默认选中状态项
    setCurrentBtnIndex(state, data) {
      state.currentBtnIndex = data
    },
    // 退车 - 点击车辆定损弹窗- 验车项目跳转到定损页面
    setJumpValueTrue(state) {
      state.isJump = true
    },
    setJumpValueFalse(state) {
      state.isJump = false
    },
    // 售车交车 - 点击车辆照片及其他弹窗- 合规照片上传跳转到合规照片上传页面
    setJumpCompliancePhotoTrue(state) {
      state.isJumpCompliancePhoto = true
    },
    setJumpCompliancePhotoFalse(state) {
      state.isJumpCompliancePhoto = false
    },
    saveDataBeforeJumpCompliancePhoto(state, data) {
      state.beforeJumpCompliancePhotoData = data
    },
    adjustmentReturnCarInfo(state) {
      if (state.returnCarInfo.fixedLossDetails.length) {
        state.returnCarInfo.fixedLossDetails.forEach(item => {
          if (!item.flag) {
            delete item.fixedLossType
            item.fixedType = 31
            item.hasOnLoss = 1
          }
        })
      }
    },
    resetReturnCarInfo(state) {
      if (state.returnCarInfo.hasOwnProperty('baseInfo')) {
        delete state.returnCarInfo.baseInfo
      }
    },
    setRepairInfo(state, evt) {
      state.repairInfo[evt.name] = evt.data
    },
    setAuth(state, evt) {
      state.auth = evt.data
    },
    setSpaceToggle(state, evt) {
      state.isSpaceToggle = evt.data
    },
    setDealScene(state, evt) {
      state.repairInfo.dealScene[evt.name] = evt.data
    },
    clearRepairInfo(state, evt) {
      state.repairInfo = {}
    },
    clearReturnInfo(state, evt) {
      state.returnInfo = {}
    },
    setUserInfo(state, evt) {
      storage.put('_userInfo', evt)
      state.userInfo = evt
    },
    setSignImg(state, evt) {
      state._signData = evt
    },
    setSelectedOrders(state, data) {
      state.selectedOrders = data
    },
    setSelectCurrentVehicle(state, item) {
      state.selectCurrentVehicle = item
    }
  },
  actions: {
    setAuth({ commit }, evt) {
      commit('setAuth', { data: evt.data })
    },
    setSpaceToggle({ commit }, evt) {
      commit('setSpaceToggle', { data: evt.isSpaceToggle })
    },
    getSign({ commit }, param) {
      return new Promise((resolve, reject) => {
        getSign(param).then(res => {
          if (res.data.display_url) {
            res.data.fileUrl = res.data.display_url + ''
            commit('setSignImg', res.data)
            resolve(res)
          } else {
            resolve({})
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
    history,
    lockCar,
    deliveryAgent
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js